import { TimeConfigI } from './time.configuration.interfaces';
import { isEqual } from 'lodash'

export class TimerConfig implements TimeConfigI {
    market = null;
    is_active = null;
    start_time = null;
    end_time = null;
    carry_forward_end_time = null;
    square_off_end_time = null;
    auto_deployment_time = null;
    after_market_deployment_time = null;

    startTimingEditing = false;
    endTimeEditing = false;

    // This is used to check if this market's time has been changed.
    originalRowString: TimeConfigI;

    constructor(conf: TimeConfigI) {
        this.update(conf);
    }

    update(conf: TimeConfigI, isDefault: boolean = false) {
        this.market = conf.market;
        this.is_active = conf.is_active;
        this.start_time = conf.start_time;
        this.end_time = conf.end_time;
        this.carry_forward_end_time = conf.carry_forward_end_time;
        this.square_off_end_time = conf.square_off_end_time;
        this.auto_deployment_time = conf.auto_deployment_time;
        this.after_market_deployment_time = conf.after_market_deployment_time;

        if (!isDefault) {
            this.originalRowString = conf;
        }
    }

    isUpdated(newTime: TimeConfigI) {
        const eq = !isEqual(this.originalRowString, newTime)
        if (eq) {
            console.log(this.originalRowString, '\n', newTime);
        }
        return eq;
    }
}
